<template>
  <div> 
    <img
      alt="kab logo"
      width="89"
      height="61"
      :src="require('@/assets/bn-w@2x.png')"
    >
  </div>
</template>

<script>
export default {
  name: "KabsLogo",
}
</script>
<style lang="scss">
</style>